<template>
	<div class="list-body">
		<ul>
			<li class="x-flow" v-for="(item,key) in posData" @click.capture="showDetail(item)">
				<router-link class="pos-link" to="">
					<div class="con-loop">
						<div class="loop-lf x-flow">
							<h5>{{item.name}}</h5>
							<ul>
								<li v-for="(list,key2) in item.details.respons" v-if="key2<3">
									{{key2 + 1}}.{{list}}。
								</li>
							</ul>
						</div>
						<div class="loop-rt x-flow"><!--<i class="x-icon-share"></i>
							<div>Share</div>-->
						</div>
					</div>
				</router-link>
			</li>
			<!--<li class="x-flow">
				<router-link class="pos-link" :to="{
                        path: '/apply',
                        query: {
                            posId: 2, to: activeName
                        }
                    }">
					<div class="con-loop">
						<div class="loop-lf x-flow">
							<h5>机械工程师 (社招)</h5>
							<ul>
								<li>1. 负责数控机床等产品的机构设计、标准件选型。</li>
								<li>2.负责产品图纸、工艺文件设计、管理。</li>
								<li>3.负责指导产品试制、量产导入。</li>
							</ul>
						</div>
						<div class="loop-rt x-flow"><i class="x-icon-share"></i>
							<div>分享</div>
						</div>
					</div>
				</router-link>
			</li>
			<li class="x-flow">
				<router-link class="pos-link" to="">
					<div class="con-loop">
						<div class="loop-lf x-flow">
							<h5>机械工程师 (社招)</h5>
							<ul>
								<li>1. 负责数控机床等产品的机构设计、标准件选型。</li>
								<li>2.负责产品图纸、工艺文件设计、管理。</li>
								<li>3.负责指导产品试制、量产导入。</li>
							</ul>
						</div>
						<div class="loop-rt x-flow"><i class="x-icon-share"></i>
							<div>分享</div>
						</div>
					</div>
				</router-link>
			</li>
			<li class="x-flow">
				<router-link class="pos-link" to="">
					<div class="con-loop">
						<div class="loop-lf x-flow">
							<h5>机械工程师 (社招)</h5>
							<ul>
								<li>1. 负责数控机床等产品的机构设计、标准件选型。</li>
								<li>2.负责产品图纸、工艺文件设计、管理。</li>
								<li>3.负责指导产品试制、量产导入。</li>
							</ul>
						</div>
						<div class="loop-rt x-flow"><i class="x-icon-share"></i>
							<div>分享</div>
						</div>
					</div>
				</router-link>
			</li>
			<li class="x-flow">
				<router-link class="pos-link" to="">
					<div class="con-loop">
						<div class="loop-lf x-flow">
							<h5>机械工程师 (社招)</h5>
							<ul>
								<li>1. 负责数控机床等产品的机构设计、标准件选型。</li>
								<li>2.负责产品图纸、工艺文件设计、管理。</li>
								<li>3.负责指导产品试制、量产导入。</li>
							</ul>
						</div>
						<div class="loop-rt x-flow"><i class="x-icon-share"></i>
							<div>分享</div>
						</div>
					</div>
				</router-link>
			</li>
			<li class="x-flow">
				<router-link class="pos-link" to="">
					<div class="con-loop">
						<div class="loop-lf x-flow">
							<h5>机械工程师 (社招)</h5>
							<ul>
								<li>1. 负责数控机床等产品的机构设计、标准件选型。</li>
								<li>2.负责产品图纸、工艺文件设计、管理。</li>
								<li>3.负责指导产品试制、量产导入。</li>
							</ul>
						</div>
						<div class="loop-rt x-flow"><i class="x-icon-share"></i>
							<div>分享</div>
						</div>
					</div>
				</router-link>
			</li>
			<li class="x-flow">
				<router-link class="pos-link" to="">
					<div class="con-loop">
						<div class="loop-lf x-flow">
							<h5>机械工程师 (社招)</h5>
							<ul>
								<li>1. 负责数控机床等产品的机构设计、标准件选型。</li>
								<li>2.负责产品图纸、工艺文件设计、管理。</li>
								<li>3.负责指导产品试制、量产导入。</li>
							</ul>
						</div>
						<div class="loop-rt x-flow"><i class="x-icon-share"></i>
							<div>分享</div>
						</div>
					</div>
				</router-link>
			</li>
			<li class="x-flow">
				<router-link class="pos-link" to="">
					<div class="con-loop">
						<div class="loop-lf x-flow">
							<h5>机械工程师 (社招)</h5>
							<ul>
								<li>1. 负责数控机床等产品的机构设计、标准件选型。</li>
								<li>2.负责产品图纸、工艺文件设计、管理。</li>
								<li>3.负责指导产品试制、量产导入。</li>
							</ul>
						</div>
						<div class="loop-rt x-flow"><i class="x-icon-share"></i>
							<div>分享</div>
						</div>
					</div>
				</router-link>
			</li>
			<li class="x-flow">
				<router-link class="pos-link" to="">
					<div class="con-loop">
						<div class="loop-lf x-flow">
							<h5>机械工程师 (社招)</h5>
							<ul>
								<li>1. 负责数控机床等产品的机构设计、标准件选型。</li>
								<li>2.负责产品图纸、工艺文件设计、管理。</li>
								<li>3.负责指导产品试制、量产导入。</li>
							</ul>
						</div>
						<div class="loop-rt x-flow"><i class="x-icon-share"></i>
							<div>分享</div>
						</div>
					</div>
				</router-link>
			</li>
			<li class="x-flow">
				<router-link class="pos-link" to="">
					<div class="con-loop">
						<div class="loop-lf x-flow">
							<h5>机械工程师 (社招)</h5>
							<ul>
								<li>1. 负责数控机床等产品的机构设计、标准件选型。</li>
								<li>2.负责产品图纸、工艺文件设计、管理。</li>
								<li>3.负责指导产品试制、量产导入。</li>
							</ul>
						</div>
						<div class="loop-rt x-flow"><i class="x-icon-share"></i>
							<div>分享</div>
						</div>
					</div>
				</router-link>
			</li>-->
		</ul>
		<div class="list-page">
			<el-pagination
			:background="true"
			@current-change="onPageChange"
			:current-page.sync="page.currentPage"
			:page-size="page.pageSize"
			:pager-count="page.pagerCount"
			layout="prev, pager, next"
			:total="page.total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
    import tools from '@/axios/index'
    export default {
        props: ['activeScope', 'activeType'],
        data() {

            return {
                activeName: 2, // 职位详情页 ID
                posData: [],
                page: {
                    currentPage: 1,
                    pageSize: 1,
                    pagerCount: 7,
                    total: 1,
                }
            };

        },
        computed: {},
        watch: {
            activeScope: {
                handler(){
                    const _this = this;
                    _this.pullData();
                },
                deep: true
            },
            activeType: {
                handler(){
                    const _this = this;
                    _this.pullData();
                },
                deep: true
            }
        },
        methods: {
            onPageChange(currentPage){
                const _this = this;
                console.log(currentPage)
                const data = {
                    page: parseInt(currentPage),
                    scope: parseInt(_this.activeScope),
                    type: parseInt(_this.activeType)
                };
                tools.getPos(data, _this);
            },
            pullData(){
                const _this = this;
                const data = {
                    page: 1,
                    scope: parseInt(_this.activeScope),
                    type: parseInt(_this.activeType)
                };
                _this.page.currentPage = 1;
                _this.page.total = 0;
                tools.getPos(data, _this);
            },
            showDetail(item){
                const _this = this;
                const activePosInfo = {
                    activePosId: item.itemid,
                    activePosName: item.name,
                    responsibility: item.details.respons,
                    requirement: item.details.require,
                };
                _this.$emit('find', {
                    activePosInfo: activePosInfo,
                    activeName: 2,
                    activeTime: (new Date()).getTime()
                })
                _this.$emit('height', {
                    type: 'screen', val: {
                        posListheight: '77.375rem',
                        posConheight: '72.875rem',
                        listConheight: '62.8125rem',
                    }
                })
                //console.log("showDetail", activePosInfo)
            },
            IsPC() {
                var userAgentInfo = navigator.userAgent;
                var Agents = ["Android", "iPhone",
                    "SymbianOS", "Windows Phone",
                    "iPad", "iPod"];
                var flag = true;
                for (var v = 0; v < Agents.length; v++) {
                    if (userAgentInfo.indexOf(Agents[v]) > 0) {
                        flag = false;
                        break;
                    }
                }
                return flag;
            }
        },
        mounted(){
            const _this = this;
            _this.pullData();
            if (!_this.IsPC()) {
                $(".pos-list,.post-con,.list-con").css({
                    height: 'initial'
                });
            } else {
				/*$(".pos-list").css({
				 height: '88.5625rem'
				 });*/
            }
            //console.log("Template[list]", _this.activeScope)
        }
    }

</script>

<style scoped>

	.x-icon-share {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_recruit_share.png");
		width: 2rem;
		height: 2rem;
	}

	.list-body {
		height: 65.6875rem;
		padding-top: 2.75rem;
	}

	.list-body > ul {
		width: 100%;
		height: 90%
	}

	.list-body > ul > li {
		width: calc((100% - 1.5rem) / 2);
		height: 10.5rem;
		background: #FFFFFF;
		box-shadow: .125rem .125rem .125rem 0 rgba(0, 0, 0, 0.06);
		border-radius: .25rem;
	}

	.list-body > ul > li:nth-child(even) {
		margin-left: 1.25rem;
	}

	.list-body > ul > li:not(:nth-last-child(1)), .list-body > ul > li:not(:nth-last-child(2)) {
		margin-bottom: 1.25rem;
	}

	.con-loop {
		width: 90%;
		height: 100%;
		margin: 0 auto;
		padding: .5rem;
	}

	.con-loop > .loop-lf {
		width: 80%;
		height: calc(100% - 1rem);
		border: none;
		overflow: hidden;
	}

	.con-loop > .loop-rt {
		width: calc(20% - 1rem);
		height: 3.75rem;
		border: none;
		vertical-align: middle;
		text-align: center;
		margin-top: 2.8125rem;
	}

	.loop-lf > h5 {
		width: 100%;
		height: 20%;
		overflow: hidden;
		font-size: 1.25rem;
		color: #3B3A38;
		line-height: 100%;
		text-align: left;
		/*word-wrap: break-word;*/
		white-space: nowrap;
		text-overflow: clip;
		display: -webkit-box;
		word-wrap: normal;
		margin-top: 1.875rem;

	}

	.loop-lf > ul {
		width: 100%;
		height: calc(100% - 2.4375rem - 20%);
		margin-top: .9375rem;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.loop-lf > ul > li {
		font-size: .875rem;
		color: #515555;
		line-height: 1.5rem;
		text-align: left;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.list-page {
		width: 100%;
		height: 10%;
		text-align: right;
	}

	.pos-link {
		display: block;
		width: 100%;
		height: 100%;
	}

</style>


// WEBPACK FOOTER //
// src/components/zh-cn/join/join-list.vue